import { graphql } from '@/gql/graphql';

export const SetChatHidden = graphql(/* GraphQL */ `
  mutation SetChatHidden(
    $chatId: uuid!
    $personId: String!
    $isHidden: Boolean!
  ) {
    insert_chat_person_preference_one(
      object: { chat_id: $chatId, person_id: $personId, is_hidden: $isHidden }
      on_conflict: {
        constraint: chat_person_preference_pkey
        update_columns: [is_hidden]
      }
    ) {
      chat_id
      person_id
      chat {
        id
        is_hidden
      }
    }
  }
`);

export const UpsertChatPersonPreference = graphql(/* GraphQL */ `
  mutation UpsertChatPersonPreference(
    $chatId: uuid!
    $personId: String!
    $notificationPreference: chat_notification_preference_enum
  ) {
    insert_chat_person_preference_one(
      object: {
        chat_id: $chatId
        person_id: $personId
        notification_preference: $notificationPreference
      }
      on_conflict: {
        constraint: chat_person_preference_pkey
        update_columns: [notification_preference]
      }
    ) {
      chat_id
      person_id
      notification_preference
    }
  }
`);
